import * as React from 'react';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import _ from 'lodash';

interface committeeType {
  committeeTypeId: string;
  committeeName: string;
  isSpecialCommittee?: boolean;
}

interface attendeeRecordProps {
  committeeChoice1: string;
  committeeChoice2: string;
  committeeChoice3: string;
}

interface ICommitteeSelectProps {
  attendeeRecord: attendeeRecordProps;
  committeeTypes: committeeType[];
  handleFormChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CommitteeSelect: React.FC<ICommitteeSelectProps> = (props) => {
  return (
    <React.Fragment>
      {/* Starting Committee Select Grid */}
      <Grid container size={{ lg: 12 }} spacing={2} className="pt-3">
        <Grid size={{ xs: 12, sm: 12, md: 7, lg: 8 }}>
          {/* Left Container */}
          <Grid container>
            <Grid size={{ xs: 12 }}>
              <h2 className="pb-2">Committee Select</h2>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container spacing={4} className="pl-4">
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
          <FormControl component="fieldset" required>
            <FormLabel component="legend">First Choice</FormLabel>
            <RadioGroup
              aria-label="committeeChoice1"
              name="committeeChoice1"
              value={props.attendeeRecord.committeeChoice1}
              onChange={props.handleFormChange}
            >
              {props.committeeTypes.map((c: committeeType) => {
                if (!c.isSpecialCommittee && !_.isEmpty(c)) {
                  return (
                    <FormControlLabel
                      key={c.committeeTypeId + '1'}
                      value={c.committeeTypeId.toString()}
                      control={<Radio />}
                      label={c.committeeName}
                      disabled={
                        String(c.committeeTypeId) ===
                          String(props.attendeeRecord.committeeChoice2) ||
                        String(c.committeeTypeId) ===
                          String(props.attendeeRecord.committeeChoice3)
                      }
                    />
                  );
                }
                return null;
              })}
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
          <FormControl component="fieldset">
            <FormLabel component="legend">Second Choice</FormLabel>
            <RadioGroup
              aria-label="committeeChoice2"
              name="committeeChoice2"
              value={props.attendeeRecord.committeeChoice2}
              onChange={props.handleFormChange}
            >
              {props.committeeTypes.map((c: committeeType) => {
                if (!c.isSpecialCommittee && !_.isEmpty(c)) {
                  return (
                    <FormControlLabel
                      key={c.committeeTypeId + '2'}
                      value={c.committeeTypeId.toString()}
                      control={<Radio />}
                      label={c.committeeName}
                      disabled={
                        String(c.committeeTypeId) ===
                          String(props.attendeeRecord.committeeChoice1) ||
                        String(c.committeeTypeId) ===
                          String(props.attendeeRecord.committeeChoice3)
                      }
                    />
                  );
                }
                return null;
              })}
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
          <FormControl component="fieldset">
            <FormLabel component="legend">Third Choice</FormLabel>
            <RadioGroup
              aria-label="committeeChoice3"
              name="committeeChoice3"
              value={props.attendeeRecord.committeeChoice3}
              onChange={props.handleFormChange}
            >
              {props.committeeTypes.map((c: committeeType) => {
                if (!c.isSpecialCommittee && !_.isEmpty(c)) {
                  return (
                    <FormControlLabel
                      key={c.committeeTypeId + '3'}
                      value={c.committeeTypeId.toString()}
                      control={<Radio />}
                      label={c.committeeName}
                      disabled={
                        String(c.committeeTypeId) ===
                          String(props.attendeeRecord.committeeChoice1) ||
                        String(c.committeeTypeId) ===
                          String(props.attendeeRecord.committeeChoice2)
                      }
                    />
                  );
                }
                return null;
              })}
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default CommitteeSelect;
